<template>
<div class="chapter">
<div class="inner_page">
<p class="C713"><a id="page_1">PART I</a></p><a id="page_1">
<p class="C704"><em>The Use of Bodies</em></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_I__THE_USE_OF_BODIES.vue?55a12a78